import { AllRipplesModal } from "@dashboard/ripples/components/AllRipplesModal";
import { useAllRipplesModalState } from "@dashboard/ripples/state";
import { Box } from "@saleor/macaw-ui-next";

import { DeprecationBanner } from "./DeprecationBanner/DeprecationBanner";
import { Menu } from "./menu/Menu";
import { MountingPoint } from "./MountingPoint";
import { UserInfo } from "./user/Info";

export const SidebarContent = () => {
  const { isModalOpen, setModalState } = useAllRipplesModalState();

  return (
    <Box
      backgroundColor="default2"
      as="aside"
      height="100%"
      display="grid"
      __gridTemplateColumns="minmax(0, 1fr)"
      __gridTemplateRows="auto 1fr auto"
    >
      <Box>
        <MountingPoint />
        <DeprecationBanner />
      </Box>
      <Menu />
      <UserInfo />
      <AllRipplesModal
        open={isModalOpen}
        onChange={open => {
          setModalState(open);
        }}
      />
    </Box>
  );
};
